export const SUBGROUP_UNASSIGNED_VALUE = "unassigned";
export const SUBGROUP_UNASSIGNED_LABEL = "(Unassigned)";
export const MAXIMUM_SUBGROUPS_PER_BRAND = 20;
export const MAXIMUM_SUBGROUP_VALUES = 50;
export const MAXIMUM_SUBGROUP_PATTERNS_PER_VALUE = 10;
export const MAXIMUM_MUTABLE_SUBGROUP_REVISION = 2_147_483_646;
/** A final successful mutation can advance the row to this terminal PostgreSQL int. */
export const MAXIMUM_SUBGROUP_REVISION = MAXIMUM_MUTABLE_SUBGROUP_REVISION + 1;
export const MAXIMUM_SUBGROUP_DEFINITION_UTF8_BYTES = 64 * 1024;
export const MAXIMUM_SELECTED_SUBGROUP_UTF8_BYTES = 128 * 1024;
//# sourceMappingURL=subgroup-constants.js.map